export default __webpack_public_path__ + "static/drive-arabia-deb8c1b59a210df295e92632a167bb81.svg";